import classNames from "classnames";
import React from "react";
function UIToggleButton(param) {
    var id = param.id, label = param.label, pressed = param.pressed, children = param.children, onToggle = param.onToggle;
    var handleKeyUp = function(e) {
        if (e.code !== "Space" && e.code !== "Enter") return;
        onToggle(!pressed);
    };
    var handleClick = function() {
        return onToggle(!pressed);
    };
    var classes = classNames("ui-toggle-button", {
        pressed: pressed
    });
    var labelId = "".concat(id, "-label");
    return /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: classes,
        "aria-labelledby": labelId,
        onKeyUp: function(e) {
            return handleKeyUp(e.nativeEvent);
        },
        onClick: function(e) {
            return handleClick(e);
        }
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only",
        id: labelId
    }, label), children);
}
export default UIToggleButton;
